export default function(text = '', threshold = 30) {
    if (text.length < threshold) return text;
    return text.slice(0, threshold) + '...';
}
